import { UseQueryResult, useQuery } from '@tanstack/react-query';

import { FlowClient, OperationMetadataModel } from '../../../api/api';
import useApiClient from '../../../common/hooks/useApiClient';

export default function useApiOperationsOfContext(contextId: string | undefined): UseQueryResult<OperationMetadataModel[], Error> {
	const client = useApiClient(FlowClient);
	const operations = useQuery({
		queryKey: ['flow', 'operations', contextId],
		queryFn: () => (contextId ? client.getOperations(contextId) : []),
	});
	return operations;
}
